// @flow
import CurrentUser from 'models/CurrentUser';

type CompliancePolicy = (user: CurrentUser) => boolean;

export type Permission = {
  authorize: (user: CurrentUser) => boolean,
  complies: (policy: CompliancePolicy) => Permission,
  is: (permission: Permission) => Permission,
  hasRoles: (...roles: string[]) => Permission
};

export default (): Permission => {
  const permissionDefinition = {
    _ownedPermissions: [],
    _ownedRoles: [],
    _compliancePolicies: [],
    is: function(permission: Permission) {
      this._ownedPermissions.push(permission);
      this._ownedRoles = [...this._ownedRoles, ...permission._ownedRoles];
      this._compliancePolicies = [
        ...this._compliancePolicies,
        ...permission._compliancePolicies
      ];
      return this;
    },
    hasRoles: function(...roles: string[]) {
      this._ownedRoles = [...this._ownedRoles, ...roles];
      return this;
    },
    complies: function(compliancePolicy: CompliancePolicy) {
      this._compliancePolicies.push(compliancePolicy);
      return this;
    },
    authorize: function(user: CurrentUser) {
      return (
        this._compliancePolicies.reduce(
          (complies, policy) => complies && policy(user),
          true
        ) &&
        this._ownedRoles.reduce(
          (complies, role) => complies && !!user.rolesMap[role],
          true
        )
      );
    }
  };

  return permissionDefinition;
};
